export const pxToRem = (htmlBodyFontSize) => (px) => {
  return Math.round((px / htmlBodyFontSize) * 1000) / 1000 + 'rem';
};
